import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { LoginService } from './login.service';
import { LoginProperties} from './login-properties';

@Component({
  selector: 'tss-login',
  template: `<div class="form-page" fxLayout="column" fxFill fxLayoutAlign="center start">      
        <form fxLayout="column" (ngSubmit)="f.form.valid && login(f.form.value,f.form.valid)" #f="ngForm" novalidate>
          
          <h1>{{options.title || 'Login'}}</h1>
      
          <div class="form-field ui-float-label">
            <input id="username" pInputText type="text" size="30" [(ngModel)]="user.userName" name="username" #username="ngModel" required>
            <label for="username">Username</label>
            <div *ngIf="f.submitted && !username.valid" class="help-block">Username is required</div>
          </div>
          <div class="form-field ui-float-label">
            <input id="password" type="password" size="30" pInputText [(ngModel)]="user.password" name="password" #password="ngModel"
              required>
            <label for="password">Password</label>
            <div *ngIf="f.submitted && !password.valid" class="help-block">Password is required</div>
          </div>
          <div class="forgt-rem-div" fxLayout="row" fxLayoutAlign="space-between center">
        
        <!--   <a routerLink="/forgot-password">Forgot Password?</a> -->
        </div>
          <button class="btn-grade" pButton type="submit" [label]="options.btnLabel || 'Submit'"></button>
        </form>
      </div>`,
  styles: [`.form-page{color:#72848c;font-size:18px}.form-page form{margin:0 auto;padding:10px}.form-page form h1{color:#323232;margin-top:0;margin-bottom:50px}.form-page form h1.logo{border-bottom:1px solid #cbcbcb;padding-bottom:10px}.form-page form .form-field{margin-bottom:30px}@media (max-width:768px){.form-page form h1{font-size:24px;padding:0}.form-page form .form-field input{margin-left:0}}.form-page form .form-field input.ui-inputtext{padding:15px;width:100%}.form-page form .form-field .help-block{color:red;bottom:-20px;font-size:16px;text-align:right}.form-page form a{color:#14b7d9}.form-page form .ui-chkbox-box{border-radius:6px}.form-page form .ui-chkbox-box.ui-state-active{background-color:#14b7d9;border:1px solid #14b7d9}.form-page form .ui-chkbox-box .ui-chkbox-icon{font-size:12px;line-height:18px}.form-page form .ui-button{padding:6px;border-radius:20px;font-size:14px}.form-page form .forgt-rem-div{margin:0 0 15px}.form-page .ui-float-label>input.ui-state-filled~label,.form-page .ui-float-label>input:focus~label{font-size:18px}`]
})

export class LoginComponent implements OnInit{
  @Input() options: LoginProperties;
  loginForm: FormGroup = new FormGroup({});
  user: any = {};
  rememberMe = false;
  btnLabel: string;
  title:string;
  
  /**
   * To store static user data in session storage on load
   * 
   * @param loginServ 
   * @see LoginService
   * @since 25-05-2018
   */
  constructor(private loginServ : LoginService) {
    this.loginServ.userData();
    
  }
  
  /**
   * html related tags to view on load. 
   *  
   * @since 25-05-2018
   */
  ngOnInit() {
    this.btnLabel = 'Submit';
    this.title = 'Login';
    this.user = {}; 
  }

  /**
   * To validate login credentials of the logged in user it will call service method.
   * 
   * @param values 
   * @param valid 
   * @see LoginService
   * @since 25-05-2018
   */
  login(values,valid){
    console.log(this.options);
    if(valid){
      this.loginServ.validate(values.username,values.password, this.options);
    }
  }
}